import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/login/Login.vue";
import ProjectsList from "../views/projectsList/ProjectsList.vue";
import BimDatabank from "../views/bimDatabank/BimDatabank.vue";
import BimDatabankCategory from "../views/bimDatabank/bimDatabankCategory/BimDatabankCategory.vue";
import BimDatabankData from "../views/bimDatabank/bimDatabankData/BimDatabankData.vue";
import Index from "../views/index/Index.vue";
import scanCode from "../views/scanCode/Index.vue";
import passageway from "../views/passageway/Index.vue";
import Program from "../views/program/Index.vue";
import engineeringModel from "../views/engineeringModel/Index.vue";
// import engineeringModel2 from "../views/engineeringModel/Index2.vue";
import Test from "../views/test/Test.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Login,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  // {
  //   path: '/home',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path: "/projectsList",
    name: "ProjectsList",
    component: ProjectsList,
  },
  {
    path: "/bimDatabank/:indexProjectString?",
    name: "BimDatabank",
    component: BimDatabank,
  },
  {
    path: "/bimDatabankCategory",
    name: "BimDatabankCategory",
    component: BimDatabankCategory,
  },
  {
    path: "/bimDatabankData/:dataId?",
    name: "BimDatabankData",
    component: BimDatabankData,
  },
  {
    path: "/index/:stype/:layout/:scenarioGroupId?/:indexProjectString?",
    name: "Index",
    component: Index,
  },

  {
    path: "/scanCode",
    name: "scanCode",
    component: scanCode,
  },

  {
    path: "/passageway",
    name: "passageway",
    component: passageway,
  },

  // {
  //   path: "/program",
  //   name: "Program",
  //   component: Program,
  //   children: [
  //     {
  //       path: "a",
  //       component: engineeringModel,
  //     },
  //     {
  //       path: "b",
  //       component: engineeringModel2,
  //     },
  //   ],
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作 next('/login')强制跳转login
router.beforeEach((to, from, next) => {
  // 访问登录页，放行
  if (
    to.path === "/login" ||
    to.path === "/scanCode" ||
    to.path === "/passageway"
  )
    return next();
  // 获取token
  const tokenStr = window.sessionStorage.getItem("token");
  // 没有token, 强制跳转到登录页
  if (!tokenStr) {
    if (sessionStorage.getItem("IsNew") == "new") {
      window.location.href = process.env.VUE_APP_NEW_URL + "/projects/list";
    } else {
      return next("/login");
    }
  }

  next();
});

export default router;
